import { createContext } from 'react';

import { useTooltip } from './useTooltip';

type ContextType = ReturnType<typeof useTooltip> | null;

export const TooltipContext = createContext<ContextType>(null);
